// Vendors
import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Container, Hamburger } from '..';

// Styles
import './mobile-nav.scss';

const MobileNavToggle = ({ mobileNav, onClick }) => (
  <div className="mobile-nav-toggle">
    <Container className="mobile-nav-toggle-container">
      <button
        className="mobile-nav-toggle-button toggle-button-override"
        onClick={onClick}
        aria-controls="mobile-nav"
        aria-label="Menu"
        aria-expanded={
          typeof mobileNav.isActive === 'boolean' ? mobileNav.isActive : false
        }
      >
        <Hamburger isActive={mobileNav.isActive} />
      </button>
    </Container>
  </div>
);

MobileNavToggle.propTypes = {
  mobileNav: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default MobileNavToggle;
